import React, { useEffect, useState } from "react";
import "./Booksdetailscard.css"
import { Rating } from 'react-simple-star-rating'

interface Booksdetailscardprops {
    book: any,
}

export default function Booksdetailscard({ book }: Booksdetailscardprops) {


    const [like, setLike] = useState(false)

    const likedislike = () => {
        if(like === true){
            setLike(false)
        }
        else{
            setLike(true)
        }
    }

    useEffect(() => {
        if (book.like === "yes") {
            setLike(true)            
        }        
    },[book.like])

    return (
        <>
            {/* Book details card start */}

            <div className="card books_details_card">
                <div className="card-header">
                    {book.discount === "yes" ? <div className="books_details_card_discount">
                        10%
                    </div> : <div></div>}
                    {like === true ? <div className="books_details_card_favourite" onClick={() => likedislike()}>
                        <img src="/assets/images/wishlist-on.png" alt="wishlist-on" />
                    </div> :
                    <div className="books_details_card_favourite"  onClick={() => likedislike()}>
                        <img src="/assets/images/wishlist-off.png" alt="wishlist-on" />
                    </div>
                    }
                </div>
                <div className="books_details_card_img">
                    <img className="card-img-top" src={book.img} alt="Card" />
                </div>
                <div className="card-body">
                    <div>
                        <h4 className="card-title">Thank You for Being Late</h4>
                        <p className="card-text">by. Thomas L Friedman</p>

                        <div className="books_details_card_prise">
                            <p className="books_details_card_discount_prise">$121</p>
                            <p className="books_details_card_original_prise">$221</p>
                        </div>
                        <div className="books_details_card_rating">
                            <Rating
                                size={9}
                                initialValue={5}
                                allowFraction
                                fillIcon={<img src="/assets/images/Star-Outline.png" alt="Star-Outline" />}
                                emptyIcon={<img src="/assets/images/Star-Outline.png" alt="Star-Outline" />}
                                readonly
                                fillColor="#E8A239"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Book details card over */}
        </>
    )

}